import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { DeleteModal } from "components/common/DeleteModal/DeleteModal";
import { DeleteIcon } from "components/common/Icons/DeleteIcon";
import { SmallContainer } from "components/common/SmallContainer/SmallContainer";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { useAppSelector } from "store/store";
import { useDeleteAll } from "./useDeleteAll";

export const DeleteAll = () => {
    const { isOpen, open, close, handleDeleteAll } = useDeleteAll();
    const { state } = useAppSelector((state) => state.compress.downloadButtonState);
    const isActive = state === "active";

    return (
        <>
            <ToolTip text={capitalize(translateFunc("delete-all"))}>
                <SmallContainer
                    className={`group cursor-pointer dark:hover:bg-darkSurface-200 py-3 px-3.5 border border-irGray-400 dark:border-darkSurface-100 rounded-xl grid items-center hover:bg-red-600 ${
                        isOpen ? "bg-gray-200 dark:bg-darkSurface-300" : "dark:bg-darkSurface-300"
                    }`}
                    onClick={() => {
                        isActive && open();
                    }}
                    data-testid="delete-modal-opener"
                >
                    <DeleteIcon width={16.84} height={20} className="group-hover:fill-white" />
                </SmallContainer>
            </ToolTip>
            <DeleteModal handleDelete={handleDeleteAll} isOpen={isOpen} close={close} />
        </>
    );
};
